import createStateReducer from "../../helpers/createStateReducer";
import reloadingFailedPaymentProcessesStates from "../../states/reloadingFailedPaymentProcesses";
import deltas from "../../actions/deltas";

const {SET_RELOADING_FAILED_PAYMENT_PROCESSES_STATE} = deltas.actionTypes;

export default createStateReducer(reloadingFailedPaymentProcessesStates, null, SET_RELOADING_FAILED_PAYMENT_PROCESSES_STATE);

export const selectIsReloadingFailedPaymentProcesses = (state) => reloadingFailedPaymentProcessesStates.LOADING === state.states.reloadingFailedPaymentProcesses.state;
